































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import StepGeneralInformation from './requirement/StepGeneralInformation.vue';
import StepRequirementTicketConfirmation from './requirement/StepRequirementTicketConfirmation.vue';
import ticketsRepository from '../../../modules/tickets/shared/repositories/tickets.repository';
import { GET_CUSTOMER_ID } from '@/modules/users/store/user.getters';
import { user } from '@/modules/shared/shared/store/namespaces';
import { Tickets, TicketType } from '@/modules/shared/shared/domain/constants/constants';
import { mapMutations } from 'vuex';
import { assistanceTypingMapping } from './utils/typings.mapping';
import { AssistanceTypingsInterface } from '@/components/tickets/tickets-form/interfaces/assistance.typings.interface';
import { createRemoteAssistanceFromToDB } from '@/components/tickets/tickets-form/utils/form-to-DB-mapping';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';

@Component({
    components: {
        TicketRequirementStepOne: StepGeneralInformation,
        TicketRequirementStepTwo: StepRequirementTicketConfirmation,
    },
    methods: {
        ...mapMutations('layout', ['changeTitle']),
    },
})
export default class TicketsRemoteAssistance extends Vue {
    errorLoadingContent: boolean = false;
    valid: boolean = false;
    highestStepReached: number = 1;
    currentStep: number = 1;
    creatingTicket: boolean = false;
    requiresTapes: boolean = false;
    timeout: number = 1000;
    formValues: {
        typings: {
            subCategories: AssistanceTypingsInterface[];
        };
    } = {
        typings: {
            subCategories: [],
        },
    };
    requirementTicket: {
        generalInformation: {
            subject: number;
            textSubject: string;
            contactId: number;
            firstName: string;
            lastName: string;
            idNumber: string;
            telephoneNumber: string;
            description: string;
        };
    } = {
        generalInformation: {
            subject: 0,
            textSubject: '',
            contactId: 0,
            firstName: '',
            lastName: '',
            idNumber: '',
            telephoneNumber: '',
            description: '',
        },
    };
    $refs!: {
        form: any;
        Step1: any;
        Step2: any;
    };

    nextStep() {
        if (this.currentStep < 2) {
            this.currentStep++;
            this.highestStepReached = this.currentStep;

            if (this.currentStep == 2) {
                this.requestData();
            }
        }
    }

    async sendRequirementTicket() {
        const requirementTicket = createRemoteAssistanceFromToDB(
            this.requirementTicket,
            this.contact,
        );
        try {
            // this.creatingTicket = true;
            EventBus.$emit(EventBusMessages.SHOW_LOADER);
            const response = await ticketsRepository.createTicket(requirementTicket);
            EventBus.$emit(EventBusMessages.HIDE_LOADER);
            this.$router.push({
                name: 'tickets',
                params: { ticket: 'success', id: response.data.id },
            });
        } catch (ex) {
            EventBus.$emit(EventBusMessages.HIDE_LOADER);
            this.$router.push({
                name: 'tickets',
                params: { ticket: 'error' },
            });
        }
    }

    getRequirementTypingSelected(value: number) {
        this.requirementTicket.generalInformation.subject = value;
        if (value == Tickets.REQUIREMENT.typings.tapeChange.id) {
            this.requiresTapes = false; // FIX RELEASE-1: originalmente es this.requiresTapes = true;
        } else {
            this.requiresTapes = false;
        }
    }

    previousStep() {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }

    requestData() {
        const stepNumbers = [1];
        stepNumbers.forEach(number => {
            Object.assign(this.requirementTicket, this.$refs['Step' + number].sendData());
        });
    }
    @Watch('currentStep')
    debugFunction(value: any, oldValue: any) {
        if (this.currentStep == 3) {
            this.requestData();
        }
    }

    async mounted() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);

        //@ts-ignore
        this.changeTitle({ title: 'Requerimiento de Asistencia Remota', route: ['TICKETS'] });

        try {
            const customerId: number = this.GET_CUSTOMER_ID;
            const response = await ticketsRepository.getDataCreateTicket(
                customerId,
                TicketType.ASSISTANCE,
            );
            const ticketTypes = response.data.values.typings;
            this.formValues.typings.subCategories = assistanceTypingMapping(ticketTypes);
        } catch (ex) {
            this.errorLoadingContent = true;
        }

        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    @user.State('contact') contact;
    @user.Getter(GET_CUSTOMER_ID) GET_CUSTOMER_ID;
}
